<template>
    <div>
        <!-- desktop -->
        <table class="table--separate table--responsive hide--sm hide--xs table">
            <thead>
                <tr>
                    <th class="table__th">Apeluri efectuate local</th>
                    <th class="table__th">Apel efectuat (EUR / minut) către RO</th>
                    <th class="table__th">Apel efectuat (EUR / minut) Internaţional SEE</th>
                    <th class="table__th">Apel efectuat (EUR / minut) International non SEE</th>
                    <th class="table__th">Apel primit EUR / minut</th>
                    <th class="table__th">SMS trimis EUR / SMS</th>
                    <th class="table__th">Trafic Date EUR / MB</th>
                </tr>
            </thead>
            <tbody class="table__body">
                <tr>
                    <td class="table__td"><strong v-html="zoneProps.Apel_local"></strong>&euro;</td>
                    <td class="table__td"><strong v-html="zoneProps.Apel_ro"></strong>&euro;</td>
                    <td class="table__td"><strong v-html="zoneProps.Apel_ue"></strong>&euro;</td>
                    <td class="table__td"><strong v-html="zoneProps.Apel_non_ue"></strong>&euro;</td>
                    <td class="table__td"><strong v-html="zoneProps.Apel_primit"></strong>&euro;</td>
                    <td class="table__td"><strong v-html="zoneProps.SMS_trimis"></strong>&euro;</td>
                    <td class="table__td"><strong v-html="zoneProps.GPRS"></strong>&euro;</td>
                </tr>
            </tbody>
        </table>
        <!-- end desktop -->

        <!-- mobile -->
        <table class="table--separate table--responsive hide--md hide--lg table">
            <thead></thead>
            <tbody class="table__body">
                <tr>
                    <td class="table__th table__td">
                        <p class="tooltip__info-text p-relativ">Apeluri efectuate local</p>
                    </td>
                    <td class="table__td"><strong v-html="zoneProps.Apel_local"></strong>&euro;</td>
                </tr>
                <tr>
                    <td class="table__th table__td">
                        <p class="tooltip__info-text p-relativ">Apel efectuat (EUR / minut) către RO</p>
                    </td>
                    <td class="table__td"><strong v-html="zoneProps.Apel_ro"></strong>&euro;</td>
                </tr>
                <tr>
                    <td class="table__th table__td">
                        <p class="tooltip__info-text p-relativ">Apel efectuat (EUR / minut) Internaţional SEE</p>
                    </td>
                    <td class="table__td"><strong v-html="zoneProps.Apel_ue"></strong>&euro;</td>
                </tr>
                <tr>
                    <td class="table__th table__td">
                        <p class="tooltip__info-text p-relativ">Apel efectuat (EUR / minut) International non SEE</p>
                    </td>
                    <td class="table__td"><strong v-html="zoneProps.Apel_non_ue"></strong>&euro;</td>
                </tr>
                <tr>
                    <td class="table__th table__td">
                        <p class="tooltip__info-text p-relativ">Apel primit EUR / minut</p>
                    </td>
                    <td class="table__td"><strong v-html="zoneProps.Apel_primit"></strong>&euro;</td>
                </tr>
                <tr>
                    <td class="table__th table__td">
                        <p class="tooltip__info-text p-relativ">SMS trimis EUR / SMS</p>
                    </td>
                    <td class="table__td"><strong v-html="zoneProps.SMS_trimis"></strong>&euro;</td>
                </tr>
                <tr>
                    <td class="table__th table__td">
                        <p class="tooltip__info-text p-relativ">Trafic Date EUR / MB</p>
                    </td>
                    <td class="table__td"><strong v-html="zoneProps.GPRS"></strong>&euro;</td>
                </tr>
            </tbody>
        </table>
        <!-- end mobile -->

        <div class="tables-disclaimer">
            <p>Prețurile includ TVA</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        selectedCountry: {
            type: Object,
            required: true,
        },
        zoneProps: {
            type: Object,
            required: true,
        },
    },
};
</script>
